import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AppBarWithMenu from '../../components/appbarwithmenu';
import { Grid, Typography, Box } from '@mui/material';
import ProfileContent from './profilecontent.js';
import Footer from '../../components/footer';
import appTheme from '../../components/apptheme';

function ProfilePage() {
  return (
    <ThemeProvider theme={appTheme}>
      <AppBarWithMenu />
      <Grid container component="main" sx={styles.containerStyle}>
        <CssBaseline />
        <Grid item xs={12} md={12} lg={12} sx={styles.contentStyle}>
          <Box sx={styles.formCardContainerStyle}>
            <Box
              component="img"
              alt="Heart Opinion"
              src={require('../../images/Person.png')}
              sx={{ mt: 4, mb: 2 }}
            />
            <Typography variant="h6">Account Summary</Typography>
            <ProfileContent />
          </Box>
        </Grid>
        <Footer />
      </Grid>
    </ThemeProvider>
  );
}

const styles = {
  containerStyle: {
    height: '93vh',
    backgroundColor: '#EDF3FC'
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // minWidth: 600,
    border: 0,
    my: 8
  },
  formCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 600,
    background: '#FFFF'
  }
};

export default function Profile() {
  return <ProfilePage />;
}
